<template>
    <div>
        <b-table
            :data="count > 0 ? subCategories : []"
            :loading="isLoading"
        >
            <template slot-scope="props">
                <b-table-column  width="40" numeric>
                    <a class="has-text-danger"
                    @click="subDetailModal=false;deleteSubcategoryModal=true; idSubToDelete=props.row.id">
                        <b-icon 
                        icon="trash"
                        size="is-small">
                        </b-icon>
                    </a>
                </b-table-column>
                <b-table-column field="id" label="ID" width="40" numeric>
                    {{props.row.id}}
                </b-table-column>
                <b-table-column field="name" label="Categoria">
                    <b-input
                    v-model="props.row.categoryTitle"
                    @input="updateSub(props.row)">
                    </b-input>
                </b-table-column>

                <b-table-column field="subcategories_count" label="Subcategoria">
                    <b-input 
                    v-model="props.row.title"
                    @input="updateSub(props.row)">
                    </b-input>
                </b-table-column>

                <b-table-column label="Editar">
                    <a 
                    @click="subModalSetup(props.row)">
                        <b-icon icon="edit" size="is-small">
                        </b-icon>
                        Editar
                    </a>
                </b-table-column>

            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                icon="frown"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>
        </b-table>

        <div class="p-top-30">
            <b-pagination
                :total="count"
                :per-page="perPage"
                :current.sync="page"
                :range-before="2"
                :rounded="true"
                :range-after="2"
                order="is-centered"
                @change="onPageChange"
                icon-prev="chevron-left"
                icon-next="chevron-right"
            >
            </b-pagination>
        </div>

        <div class="columns m-t-30">
            <div class="column is-full has-text-centered">
                <b-button
                type="is-primary"
                rounded
                @click="subDetailModal=false; addCategoryModalStatus=true">
                    <b-icon
                    icon="plus"
                    size="is-small">
                    </b-icon>
                   Agrega nuevas secciones a la tienda
                </b-button>
            </div>
        </div>

        <b-modal :active.sync="deleteSubcategoryModal" scroll="keep">
            <div class="modal-card" style="width: auto">
                

                <div class="modal-card-body has-text-centered">
                    <p>
                        Eliminar esta subcategoria va a hacer que los productos vinculados a ella queden con el campo nulo,
                        por ende no seran visibles en el sitio.
                    </p>
                    <p> <b>Seguro que quieres continuar?</b> </p>
                    <div class="columns m-t-20">
                        <div class="column has-text-centered is-full">
                            <b-button
                                type="is-grey"
                                rounded
                                @click="deleteSubcategoryModal=false">
                                    Cancelar
                            </b-button>
                            <b-button
                                type="is-danger"
                                rounded
                                @click="deleteSubcategory">
                                    Eliminar
                            </b-button>
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </b-modal>

        <b-modal :active.sync="addCategoryModalStatus" scroll="keep">
            <div class="modal-card" style="width: auto">
                <div class="modal-card-body has-text-centered">
                    <b-tabs v-model="activeTab">
                        <b-tab-item label="Nuevas categorias">
                            <b-field 
                            label="Titulo"
                            label-position="on-border"
                            v-for="(x,i) in newCategories"
                            :key="i"
                            expanded
                            grouped>
                                <b-input
                                max="60"
                                type="text"
                                class="m-t-5"
                                v-model="x.title"
                                >
                                </b-input>
                                <p class="control">
                                    <a class="has-text-danger"
                                    @click="deleteNewCat(i)">
                                        <b-icon icon="trash" size="is-small"></b-icon>
                                    </a>
                                </p>
                            </b-field>
                            <a class=" buttons has-text-grey has-text-left m-b-30"
                            @click="addNewCat">
                                <b-icon icon="plus" size="is-small"></b-icon>
                                Nueva fila
                            </a>

                            <div class="m-t-10">
                                <b-button
                                type="is-primary"
                                rounded
                                :loading="loadCreateCategory"
                                @click="createCategories">
                                    <b-icon icon="save" size="is-small"></b-icon>
                                    Crear categorias 
                                </b-button>
                            </div>
                        </b-tab-item>

                        <b-tab-item label="Nueva subcategoria">
                            <div v-for="(sub,i) in newSubs" :key="i" class="columns is-multiline border-bottom">
                                <div class="column is-full has-text-left" style="padding:0; margin:0;">
                                    <a class="has-text-danger"
                                    @click="deleteNewSub(i)">
                                        <b-icon 
                                        icon="trash"
                                        size="is-small">
                                        </b-icon>
                                        Delete subcategory
                                    </a>
                                </div>
                                <div class="column is-half">
                                    <b-field
                                    label="Padre">
                                        <b-select
                                        :loading="categoryLoading"
                                        expanded
                                        v-model="sub.category">
                                            <option v-for="x in categories" :value="x.id" :key="x.id">{{x.title}}</option>
                                        </b-select>
                                    </b-field>
                                </div>
                                <div class="column is-half">
                                    <b-field label="Titulo" >
                                        <b-input
                                        type="text"
                                        max="60"
                                        v-model="sub.title">
                                        </b-input>
                                    </b-field>
                                </div>
                            </div>

                            <a class=" buttons has-text-grey has-text-left m-b-30"
                            @click="addNewSub">
                                <b-icon icon="plus" size="is-small"></b-icon>
                                Nueva linea
                            </a>

                            <div class="m-t-10">
                                <b-button
                                type="is-primary"
                                rounded
                                :loading="loadCreateSubcategories"
                                @click="createSubcategories">
                                    <b-icon icon="save" size="is-small"></b-icon>
                                    Crear subcategorias
                                </b-button>
                            </div>
                        </b-tab-item>
                    </b-tabs>
                </div>
            </div>
        </b-modal>
        
        <SubModal 
        :showModal="subDetailModal"
        :item="subDetailItem"
        @update="updateSub"
        />

    </div>
</template>

<script>
import {getHandler, postHandler, debounce, patchHandler, deleteHandler} from "./../../../../services/http.js"
import SubModal from "./SubModal"
export default {
    components:{
        SubModal
    },
    name:"CategoryTable",
    props:{
        subcategoryListEndpoint:{
            type:String,
            default:""
        },
        categoryListEndpoint:{
            type:String,
            default:""
        }, 
        subcategoryDetail:{
            type:String,
            defult:""
        },
        count:{
            type:Number,
            default:0
        },
        isLoading:{
            type:Boolean,
            default:false
        },
        categoryLoading:{
            type:Boolean,
            default:false
        },
        categories:{
            type:Array,
            default: new Array([])
        },
        subCategories:{
            type:Array,
            default: new Array([])
        },
        page:{
            type:Number,
            default:1
        }
    },
    data(){
        return{
            perPage:24,
            addCategoryModalStatus:false,
            activeTab:0,
            newCategories:[{title:""},],
            loadCreateCategory:false,
            newSubs:[{category:0,title:""},],
            loadCreateSubcategories:false,
            subDetailModal:false,
            subDetailItem:null,
            idSubToDelete:"",
            deleteSubcategoryModal:false
        }
    },
    methods:{
        fetchSubCategories(){
            this.$emit("loadSubs", this.page)
        },
        fetchCategories(){
            this.$emit("loadCategories")
        },
        async createCategories(){
            this.loadCreateCategory = true
            let msg = {
                resource:"notify"
            }
            let response = await postHandler(this.categoryListEndpoint, this.newCategories, {error:msg, success:msg})
            this.newCategories = [{title:""},]
            this.loadCreateCategory = false
            this.fetchSubCategories()
            this.fetchCategories()
        },

        async createSubcategories(){
            this.loadCreateSubcategories=true
            let msg = {
                resource:"notify"
            }
            let response = await postHandler(this.subcategoryListEndpoint, this.newSubs, {error:msg, success:msg})
            this.newSubs = [{category:0,title:""},]
            this.loadCreateSubcategories=false
            this.fetchSubCategories()
            this.fetchCategories()
        },

        async deleteSubcategory(){
            let msg = {
                resource:"toast"
            }
            let url = this.subcategoryDetail.replace('0000', this.idSubToDelete)
            let response = deleteHandler(url, {error:msg, success:msg})
            this.deleteSubcategoryModal = false
            this.fetchSubCategories()
            
        },

        updateSub: debounce(
            async function(data){
                let msg = {
                    resource:"toast"
                }
                let url = this.subcategoryDetail.replace('0000', data.id)
                let response = await patchHandler(url, data, {error:msg, success:msg})
                this.subDetailModal=false
                this.fetchSubCategories()
            },
            700
        ),

        onPageChange(page){
            this.$emit("pageChange", page)
            this.fetchSubCategories()
        },
        addNewCat(){
            this.newCategories.push({title:""})
        },
        deleteNewCat(index){
            this.newCategories.splice(index, 1)
        },
        addNewSub(){
            this.newSubs.push({category:0,title:""})
        },
        deleteNewSub(index){
            this.newSubs.splice(index, 1)
        },
        subModalSetup(item){
            this.deleteSubcategoryModal=false
            this.subDetailModal=false
            this.subDetailModal=true
            this.subDetailItem=item
        }
    },

}
</script>

<style lang="scss" scoped>
.border-bottom{
    border-bottom: 0.8px #ddd solid;
}
</style>
